import { uiImages } from './images';
import { mc } from "@lss/common/game/characters/MC";
import ImageClass from "@lss/common/src/shell/Image";
import Question from "../../src/shell/Questions";
import { pcLady } from "../characters/PCLady";
import { images } from "@lss/common/game/story/images";
import { jump } from "../../src/shell/jump";
import UI from "../../src/shell/UI";
import { joe } from '../characters/Joe';
import { vanessa } from '../characters/Vanessa';
import { ann } from '../characters/Ann';
import { empty } from '../characters/empty';
import { chris } from '../characters/Chris';
import Game from '../../src/shell/Game';
import { Insta } from '../../src/components/insta/InstaClass';
import { alex } from '../characters/Alex';
import { TODManager } from './V2.5';
import { getInstaData } from '../helpers/InstaPostsHelpers';
import { alexProfilesPic } from '../helpers/alexInstaImages';
import { doDoorRing, getInstaImage } from '../helpers/helpers';





export const AfterBarAtHome = async () => {
    ImageClass.setImage(images.v1.Room1);
    pcLady.talk(`That was a busy day.`, { method: "Over Chat" });
    mc.talk(`Yeah it really was.`, { method: "On Chat" });

    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {
        pcLady.talk(`I still haven't figured out if you like Ann or not.`, { method: "Over Chat" });
        mc.talk(`I'll get to that.`, { method: "On Chat" });
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {

            pcLady.talk(`If you do, why the hell did you let that bartender get her number?`, { method: "Over Chat" });
            mc.talk(`Curious! You should have listened the first time!`, { method: "On Chat" });
            mc.talk(`But I'll get to that again really soon.`, { method: "On Chat" });
        }

    } else {
        pcLady.talk(`I can't believe you went with Vanessa instead of Ann.`, { method: "Over Chat" });
        pcLady.talk(`That slut!\nI bet she always gets what she wants.`, { method: "Over Chat" });
        mc.talk(`I had my reasons.\nIt'll all become clear for you real soon.`, { method: "On Chat" });

    }


    pcLady.talk(`Come on now, get to the juicy parts!!!`, { method: "Over Chat" });
    pcLady.talk(`All I read is how you go around talking to people, I want more A-C-T-I-O-N!`, { method: "Over Chat" });
    mc.talk(`Patience. If I skip stuff it won't make sense. I gotta set it up for you.`, { method: "On Chat" });
    pcLady.talk(`I should have said that I was listening to the beginning...`, { method: "Over Chat" });
    mc.talk(`I can stop if I'm boring you.`, { method: "On Chat" });
    pcLady.talk(`No no, sorry! Please continue, I'm listening.`, { method: "Over Chat" });

    mc.talk(`Alright.`, { method: "On Chat" });
    mc.talk(`So the next day, I was chilling in my room...`, { method: "On Chat" });
    return jump(atHomeRoutine1, "atHomeRoutine1");

};
export const atHomeRoutine1 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    if (!Game.seenScenarios.includes(`atHomeRoutine1`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 23;
            properties.instaFollowers = 515;
        });
    }

    await UI.add({
        key: "V2firstBeforeCallingJoe",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Call Joey", key: "callJoey" }
            ]
    });
    if (UI._globalUI.V2firstBeforeCallingJoe === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.V2firstBeforeCallingJoe === "callJoey") {
        return jump(beachVanessaJoe, "beachVanessaJoe");
    }

    return jump(atHomeRoutine1, "atHomeRoutine1");
};

export const beachVanessaJoe = async (): Promise<any> => {


    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {
        mc.think(`Joey wanted an update about my meeting with Ann.`);
        mc.think(`Nothing really happened there, she looks like the kind of girl that takes things slow.`);
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
            mc.think(`Although she did give her number to that bartender, Chris.`);
        }
    } else {
        mc.think(`Joey can't know I went out with Vanessa instead of Ann. I don't feel comfortable lying to him, but I did promise Vanessa I wouldn't tell him.`);
        mc.think(`Besides, it's for a good cause, I don't want to ruin his birthday with my big mouth.`);
        mc.think(`I need to come up with a good lie about how my date with Ann went, so he won't suspect anything.`);
    }

    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingJoey);
    mc.think(`Time to give him a call.`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    mc.think(`...`);
    mc.think(`Come on Joey, pick up.`);
    mc.think(`No response.`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    mc.think(`He's usually at the beach at this time of day. I don't have anything better to do, so I might as well go look for him.`);

    ImageClass.setImage(images.v2.BeachMain2);
    mc.think(`There he is, always in the same spot.`);
    mc.think(`He's not alone.`);
    mc.think(`That must be Vanessa with him.`);

    ImageClass.setImage(images.v2.JVBeachNatural);

    if (mc.properties.metVanessa === false) {
        mc.talk(`Hey Joey.`);
        joe.talk(`Hey ${mc.name}.`);

        vanessa.talk(`${mc.name}? Joe has told me so much about you!`);
        if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
            mc.think(`Since she is acting like she didn't meet me I guess Joey doesn't know a thing.`);
        }
        joe.talk(`Oh right, Vanessa, this is ${mc.name}. ${mc.name} meet Vanessa.`);
        vanessa.talk(`Nice to meet you!`);

    } else {
        mc.talk(`Hey Joey, hey Vanessa.`);
        joe.talk(`Hey ${mc.name}.`);
        vanessa.talk(`Hey ${mc.name}!`);

    }

    joe.talk(`Join us.`);
    mc.talk(`Nah, I just wanted to talk to you about something, but I see that you're busy so I'll catch you later.`);
    joe.talk(`Don't be ridiculous! We're all friends here, you can say whatever.`);
    joe.talk(`Oh!\nI just remembered, is this about your date with Ann? How was it?`);
    vanessa.talk(`Date with Ann? Yes, how was it?`);
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        mc.think(`She knows exactly how it went...`);

    }

    mc.talk(`It was alright.`);
    joe.talk(`Come on, spill it.`);
    vanessa.talk(`We want details!`);
    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {

        mc.talk(`Fine.`);
        mc.talk(`So we went out, I ordered a beer and she asked for water.`);
        vanessa.talk(`Sounds like her.`);
        mc.talk(`We talked for a bit about our hobbies.`);
        joe.talk(`Come on, get to the interesting part!`);
        mc.talk(`There wasn't any, that's about it.`);
        joe.talk(`Didn't you kiss at least?`);
        mc.talk(`No.`);
        vanessa.talk(`Now I know he ain't lying.`);

        await joe.setQuestion(new Question({ text: `Why? Don't you like her?`, key: `v2DoYouLikeAnn` })
            .option({ title: `I like Her`, key: 'yes' })
            .option({ title: `I don't like her`, key: 'no' })
            .option({ title: `Not sure yet`, key: 'notSure' }));

        if (Question.globalAnswers.v2DoYouLikeAnn === "yes") {
            mc.talk(`I do like her.`);
            joe.talk(`So?`);
            mc.talk(`We didn't have a moment.`);
            joe.talk(`You need to make a moment.`);
            vanessa.talk(`Joe and I have a moment every few hours haha.`);
            mc.talk(`She takes things very slow and I respect it.`);
            mc.talk(`It will happen, it just takes more time than usual.`);
            joe.talk(`Alright dude. If you are good, I'm happy for you!`);

        } else if (Question.globalAnswers.v2DoYouLikeAnn === "no") {

            mc.talk(`Not really.`);
            joe.talk(`Why not? What's wrong?`);
            mc.talk(`She is kinda shy, she takes things VERY slow, not my type.`);
            joe.talk(`That's too bad man. So, is it over? Aren't you going to meet with her again?`);
            mc.talk(`It feels uncomfortable talking about her when Vanessa is right here...`);
            vanessa.talk(`Come on! Do you think I care?`);
            vanessa.talk(`I think you should keep seeing her even if you don't like her, it's time for her to get a decent dick inside her haha.`);
            mc.talk(`Wow, ok.`);
            vanessa.talk(`But let me tell you this...`);
            vanessa.talk(`That's the major problem with Ann, it's hard to get close to her because she is so closed and shy.`);
            vanessa.talk(`I thought it would be different with you since you both have some things in common. Personality-wise.`);
            joe.talk(`It's not over yet! Time will tell what will happen.`);
        } else {
            mc.talk(`Still figuring this one out. We just met once yesterday and all we did was talk, I need a few more dates to see where the wind is blowing.`);
            joe.talk(`I can bring a fan to help you out with that.`);
            mc.talk(`Haha.`);
            vanessa.talk(`She is cute, just give her time and she will open up! No worries.`);

            mc.talk(`Maybe I will, we will see.`);
            vanessa.talk(`That's the major problem with Ann, it's hard to get close to her because she is so shy.`);
            vanessa.talk(`I thought it will be different with you since you both have some things in common. Personality-wise.`);
            joe.talk(`It's not over yet! Time will tell what will happen.`);
        }

    }

    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {

        mc.talk(`There is nothing to tell really. We went out, got some drinks, and headed home.`);
        vanessa.talk(`Probably water because she doesn't drink right?`);
        mc.talk(`Yeah, she ordered water.`);
        joe.talk(`Really? Boring.`);
        vanessa.talk(`That's how she is, I bet they probably just sat down and talked the whole evening without doing anything exciting right?`);
        mc.talk(`Yes, that's exactly what happened.`);
        joe.talk(`Let the man talk Vanessa! You act like you were there.`);
        joe.talk(`Come on ${mc.name}, give me details.`);
        mc.talk(`What Vanessa said was about right. That's all that happened.`);

        await joe.setQuestion(new Question({ text: 'Really? Nothing interesting happened?', key: `v2BeachTeaseVannesa` })
            .option({ title: `Tease Vanessa`, key: true })
            .option({ title: `Don't tease`, key: false }));

        if (Question.globalAnswers.v2BeachTeaseVannesa) {
            mc.talk(`Well... She sorta looked like she is into the bartender. Like a lot.`);
            joe.talk(`That bastard! How do you know?`);
            ImageClass.setImage(images.v2.JVBeachSurprise);
            mc.talk(`She laughed at his jokes, and looked at him in that way girls do when they are into someone.`);
            joe.talk(`But at the end of the day, she came and left with you right?`);
            mc.talk(`About that...`);
            vanessa.talk(`Of course she did. This is Ann we're talking about! Right ${mc.name}??`);
            mc.talk(`Yeah, that's what happened.`);
            joe.talk(`Ok good.`);
        } else {

            mc.talk(`Nope, that's all dude.`);
            joe.talk(`Oh well... Maybe you'll get lucky next time.`);
        }

    }
    return jump(beachVanessaJoe2, "beachVanessaJoe2");
    // <action type="jump" scenario="beachVanessaJoe2"/>
};

export const beachVanessaJoe2 = async (): Promise<any> => {

    ImageClass.setImage(images.v2.JVBeachNatural);
    joe.talk(`By the way, do you remember that it's my birthday in a couple of days?`);
    mc.talk(`Yes, I remember.`);
    joe.talk(`Vanessa said she has something special in mind for me! I can't wait.`);
    vanessa.talk(`Patience!`);
    joe.talk(`I know...`);
    joe.talk(`Anyway. I am heading out to the gym.`);
    joe.talk(`Vanessa are you good here? Do you need a ride home?`);
    vanessa.talk(`I'm good. ${mc.name} will keep me company.`);
    mc.talk(`Sure, I can do that.`);
    joe.talk(`Great! Have fun you two.`);
    mc.talk(`Cya Joey.`);
    vanessa.talk(`Bye Honey.`);
    ImageClass.setImage(images.v2.VenBeach2, { duration: 0.6 });
    vanessa.talk(`Why are you still standing?`);
    vanessa.talk(`Join me.`);
    mc.talk(`Sure.`);
    ImageClass.setImage(images.v2.VenBeach1);

    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {

        vanessa.talk(`So! What really happened with Ann?`);
        mc.talk(`I told you everything.`);
        vanessa.talk(`We both know that's a lie.\nYou didn't seem too excited about your date, so something must have happened.`);
        mc.talk(`Now that you mention it, there was this one thing.`);
        vanessa.talk(`I knew it.`);
        mc.talk(`The bartender there, he was into her.`);
        vanessa.talk(`Into her? I bet he just wanted to fuck her, but knowing Ann, he would give up after a few minutes into their conversation.`);
        vanessa.talk(`And what makes you so sure he wants her? Maybe you are just imagining things.`);
        mc.talk(`I didn't mention that as soon as Ann left for the restroom he came and asked me if she was my girlfriend.`);
        vanessa.talk(`And what did you say?`);
        mc.talk(`I said she isn't so he asked if he could ask her for her number.`);
        vanessa.talk(`In front of you?`);
        mc.talk(`Yes.`);
        vanessa.talk(`SO??? Keep going!`);
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {

            mc.talk(`I didn't mind, so I said yes.`);
            mc.talk(`Once Ann had came back, he joined us again and asked her for her number, so she gave it to him.`);
            vanessa.talk(`OH MY GOD! No way! Ann? What a slut! She gave her number to some random guy???`);
            mc.talk(`Yup.`);
            vanessa.talk(`I never would have thought she had that in her.`);
            vanessa.talk(`Does it bother you?`);
            mc.talk(`I don't think so, but it was strange having a guy hitting on her when I was sitting right there.`);
            vanessa.talk(`He did ask for your permission, so you can't really blame him.`);
            mc.talk(`Yeah... That's true.`);
        } else {

            mc.talk(`I said no and he respected that.`);
            vanessa.talk(`Cool, she wouldn't have given it to him anyways.`);
            mc.talk(`I guess you are right.`);
        }

    } else {
        if (Question.globalAnswers.v2BeachTeaseVannesa) {
            vanessa.talk(`OMG! You are a jerk! You almost told him everything!`);
            mc.talk(`No, I didn't. It was just to make you nervous.`);
            vanessa.talk(`Well. It worked.`);
            mc.talk(`That was my point.`);
            vanessa.talk(`Why would you want to do that?`);
            mc.talk(`I don't know, why did you stay with the bartender at the bar?`);
            vanessa.talk(`I know him, he is a friend of mine.`);
            mc.talk(`We both know that's a lie, you didn't know him when he came to serve us.`);
            vanessa.talk(`That's just a thing we do when we meet.`);
            vanessa.talk(`We pretend to not know each other just for the laughs.`);
            mc.think(`I don't believe her but I'll give her the benefit of the doubt.`);
            mc.talk(`Fine, I just don't want Joey's feelings to get hurt.`);
        } else {
            vanessa.talk(`Thanks for keeping quiet.`);
            mc.talk(`I really didn't have a choice. I don't want to hurt his feelings.`);
        }
        vanessa.talk(`Haha! Why would his feelings get hurt?`);
        vanessa.talk(`The only thing that will hurt his feelings is knowing you can't keep a secret.`);
        vanessa.talk(`I bet you'll tell him everything the first chance you get.`);
        mc.talk(`That's not true.`);
        vanessa.talk(`Fine, prove me wrong.`);
        mc.talk(`Joey just left without knowing a thing.`);
        vanessa.talk(`Good point.`);
    };

    return jump(beachVanessaAlone, "beachVanessaAlone");
};

export const beachVanessaAlone = async (): Promise<any> => {

    ImageClass.setImage(images.v2.VenBeach1);
    vanessa.talk(`Well, enough about that!`);
    vanessa.talk(`Do you have any plans for the next few hours?`);
    mc.talk(`Nothing special. Why?`);
    vanessa.talk(`I need your help with something.`);
    mc.talk(`With what?`);
    vanessa.talk(`I'm having a hard time finding something to wear for Joe's birthday, and since you are his best friend I bet you can help me out!`);
    mc.talk(`I don't think that's a good idea.\nBesides, I know nothing about women's clothing.`);
    vanessa.talk(`Come on!\nYou are the best person to help me out with that.`);
    vanessa.talk(`It wouldn't take long.`);
    mc.talk(`...`);
    vanessa.talk(`PLEASEEE!`);
    mc.talk(`Fine...`);
    vanessa.talk(`You're the best!`);
    vanessa.talk(`Let's go!`);
    return jump(VanessasRoom1, "VanessasRoom1");

};
export const VanessasRoom1 = async (): Promise<any> => {


    ImageClass.setImage(images.v2.VanessaHomeDoor);

    vanessa.talk(`So, here we are!`);
    mc.talk(`Wow... Your room... It's so... Pink.`);
    vanessa.talk(`I know right! It's the best color in the world.`);
    vanessa.talk(`Come, get in.`);
    ImageClass.setImage(images.v2.VanessaHomeBikini);

    vanessa.talk(`Ok, so I have a few cute dresses I like.`);
    mc.talk(`I am regretting this already.`);
    vanessa.talk(`Shush!`);
    vanessa.talk(`Just wait here, I'll go change and come back.`);

    ImageClass.setImage(images.v2.VanessaHomeAlone);
    mc.think(`When I woke up this morning, I never would've guessed I'd be playing fashion consultant...`);


    ImageClass.setImage(images.v2.VanessaHomeWhite);
    vanessa.talk(`So this is my first dress.`);
    vanessa.talk(`White. I like it, it makes me feel like a beautiful bride.`);
    ImageClass.setImage(images.v2.VanessaHomeWhite2);
    vanessa.talk(`But I do feel like the cleavage is too deep.`);
    ImageClass.setImage(images.v2.VanessaHomeWhite3);

    await vanessa.setQuestion(new Question({ text: `What do you think? Is it too deep?`, key: `v2VanessaClothesIsItDeep` })
        .option({ title: `It is`, key: `yes` })
        .option({ title: `It's not`, key: `no` }));
    if (Question.globalAnswers.v2VanessaClothesIsItDeep === "yes") {

        mc.talk(`Yeah... I think it's too deep.`);
        ImageClass.setImage(images.v2.VanessaHomeWhite2);
        vanessa.talk(`I knew it.`);
    } else {
        mc.talk(`I don't think it's too deep.`);
        vanessa.talk(`Really? It must be just me then.`);
    }
    ImageClass.setImage(images.v2.VanessaHomeWhite);

    await vanessa.setQuestion(new Question({ text: `Do you like it overall?`, key: `v2VanessaClothesDeepOverall` })
        .option({ title: `Yes`, key: `yes` })
        .option({ title: `Flirtatious Yes`, key: `flirt` })
        .option({ title: `No`, key: `no` }));

    if (Question.globalAnswers.v2VanessaClothesDeepOverall === "yes") {

        mc.talk(`Yes, I think it's nice.`);
        vanessa.talk(`Don't make my life hard! I have a few more dresses!`);
    } else if (Question.globalAnswers.v2VanessaClothesDeepOverall === "flirt") {
        await mc.set((properties) => {
            properties.vanessaRelationship = properties.vanessaRelationship + 2;
        });

        mc.talk(`Yes, you look beautiful in it.`);
        ImageClass.setImage(images.v2.VanessaHomeWhite4);
        vanessa.talk(`Aww... Do you really think so?`);
        mc.talk(`I really do.`);
        vanessa.talk(`Wait till you see my next dress!`);

    } else {
        mc.talk(`Not so much.`);
        vanessa.talk(`Oh... Good thing I have a bunch more to show you!`);

    }
    vanessa.talk(`Wait here, I'll go change real quick.`);
    ImageClass.setImage(images.v2.VanessaHomeAlone);
    mc.think(`The anticipation...`);
    ImageClass.setImage(images.v2.VanessaHomeBlack1);
    vanessa.talk(`Ok, so I have this black dress.`);
    vanessa.talk(`The cleavage is not as deep as the previous one.`);





    return jump(VanessasRoom2, "VanessasRoom2");
};

export const VanessasRoom2 = async (): Promise<any> => {

    ImageClass.setImage(images.v2.VanessaHomeBlack1);

    await vanessa.setQuestion(new Question({ text: `What do you think? Is it better?`, key: `v2VanessaClothesBlackDressBetter` })
        .option({ title: `Yes`, key: `yes` })
        .option({ title: `No`, key: `no` })
        .option({ title: `Flirtatious yes`, key: `flirt` }));

    if (Question.globalAnswers.v2VanessaClothesBlackDressBetter === "yes") {
        mc.talk(`Yes, it is.`);
        vanessa.talk(`Oh really? Don't you think I look like a widow?`);
        mc.talk(`Not at all, it's nice.`);
    } else if (Question.globalAnswers.v2VanessaClothesBlackDressBetter === "flirt") {
        await mc.set((properties) => {
            properties.vanessaRelationship = properties.vanessaRelationship + 2;
        });
        mc.talk(`It is, but everything looks good on you.`);
        vanessa.talk(`Aww, come on stop it! Haha.`);
    } else {
        mc.talk(`The white one is better.`);
        vanessa.talk(`Really?`);
        vanessa.talk(`I mean, I do like them both, but I thought this one is better.`);
    }
    vanessa.talk(`The only problem I have with this one, is that it seems too short.`);
    ImageClass.setImage(images.v2.VanessaHomeBlack2);
    vanessa.talk(`Like, look, you can almost see my panties.`);

    ImageClass.setImage(images.v2.VanessaHomeBlack3);

    await vanessa.setQuestion(new Question({ text: `Don't you agree?`, key: `v2VanessaClothesBlackDressShort` })
        .option({ title: `It's sexy`, key: `itsSexy` })
        .option({ title: `It's too short`, key: `itsTooShort` }));

    if (Question.globalAnswers.v2VanessaClothesBlackDressShort === "itsSexy") {
        mc.talk(`It's sexy.`);
        ImageClass.setImage(images.v2.VanessaHomeBlack1);
        vanessa.talk(`Look at you! I thought you might like your girls a little more conservative.`);
        mc.talk(`I don't.\nAnd you are Joey's girl not mine.`);
        vanessa.talk(`You have a point.`);
    } else {
        mc.talk(`I agree that it's too short.`);
        ImageClass.setImage(images.v2.VanessaHomeBlack2);
        vanessa.talk(`I knew it...`);
    }

    return jump(VanessasRoom3, "VanessasRoom3");
};

export const VanessasRoom3 = async (): Promise<any> => {

    ImageClass.setImage(images.v2.VanessaHomeBlack1);
    vanessa.talk(`Ok, last dress, you know the drill, wait here.`);
    ImageClass.setImage(images.v2.VanessaHomeAlone);
    mc.think(`Last one.`);

    ImageClass.setImage(images.v2.VanessaHomeBlackRed1);
    vanessa.talk(`This is the last dress!`);
    vanessa.talk(`The first one has the huge cleavage.`);
    vanessa.talk(`With the second, my panties were almost visible.`);
    vanessa.talk(`And this one has it all!`);
    await vanessa.setQuestion(new Question({ text: `What do you think?`, key: `v2VanessaClothesRedBlackDress` })
        .option({ title: `I like it`, key: `iLikeIt` })
        .option({ title: `Way too much`, key: `wayTooMuch` })
        .option({ title: `Remove the panties`, key: `removePanties` }));
    if (Question.globalAnswers.v2VanessaClothesRedBlackDress === "iLikeIt") {
        mc.talk(`I like it.`);
        await mc.set((properties) => {
            properties.vanessaRelationship++;
        });
        vanessa.talk(`I knew you would like it.\nIt's my favorite dress!`);
        mc.talk(`If that's your favorite why did you invite me to come over and help you choose?`);
        vanessa.talk(`I wanted to be sure. And now I am.`);
    } else if (Question.globalAnswers.v2VanessaClothesRedBlackDress === "wayTooMuch") {
        mc.talk(`That's too much; you are almost naked.`);
        vanessa.talk(`Sorry Dad, I'll go get dressed.`);
    } else {
        await mc.set((properties) => {
            properties.vanessaRelationship = properties.vanessaRelationship + 2;
        });
        mc.talk(`The panties ruin the overall look, you should remove them.`);

        if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {

            await mc.set((properties) => {
                properties.vanessaRemovedPanties = true;
            });
            vanessa.talk(`That's a great idea!`);
            vanessa.talk(`I had the same thought when I first put it on.`);
            ImageClass.setImage(images.v2.VanessaHomeBlackRed3);
            vanessa.talk(`You are a great help, I'm really glad you came over.`);
            mc.talk(`Oh wow, you're doing it right now.`);
            vanessa.talk(`Sure, why not? Haha.`);
        } else {

            await vanessa.talk(`That's a great idea, I might do that when I wear it for Joe. Haha.`);
            if (mc.properties.vanessaRelationship >= 2) {

                mc.talk(`You should do it now so I can make a better judgment...`);
                vanessa.talk(`Haha, don't be silly!`);
                mc.think(`At least I tried.`);
            }
        }

    }
    return jump(beachVanessaAlone4, "beachVanessaAlone4");
};

export const beachVanessaAlone4 = async (): Promise<any> => {
    ImageClass.setImage(images.v2.VanessaHomeBlackRed5);

    vanessa.talk(`I do have one last thing...`);

    if (mc.properties.vanessaRelationship > 0 && Question.globalAnswers.v1WentToTheBarWith === "vanessa") {

        return jump(beachVanessaAlone5, "beachVanessaAlone5");
    }

    vanessa.talk(`You've seen my dresses, but I still have a late night surprise for Joe that I would like to have your opinion on.`);

    await vanessa.setQuestion(new Question({ text: `Would you like to see it?`, key: `v2VanessaClothesSeeNightWear` })
        .option({ title: `Yes`, key: true })
        .option({ title: `No`, key: false }));


    if (Question.globalAnswers.v2VanessaClothesSeeNightWear) {
        mc.talk(`Sure, show me.`);
        vanessa.talk(`Hold your horses!`);
        ImageClass.setImage(images.v2.VanessaHomeAlone);
        mc.think(`This should be good.`);
        ImageClass.setImage(images.v2.VanessaHomePJ);
        vanessa.talk(`There it is!`);
        mc.talk(`Wow, you can clearly see everything.`);
        vanessa.talk(`That's the point.`);
        mc.talk(`Point clearly delivered.`);
        vanessa.talk(`Ok that's all.`);
    } else {
        mc.talk(`Nah, I've seen enough already.`);

        vanessa.talk(`You know your way out right? I'll go take a shower.`);
    }

    return jump(beachVanessaAlone6, "beachVanessaAlone6");
};

export const beachVanessaAlone5 = async (): Promise<any> => {

    ImageClass.setImage(images.v2.VanessaHomeAlone);
    mc.think(`She just left.`);
    mc.think(`I wonder what she is planning.`);
    // <action type="vmod" name="temp.vanessaHomeDress" do="set" value="3"/>

    ImageClass.setImage(images.v2.VanessaHomeTease);
    vanessa.talk(`Surprise!`);
    mc.talk(`Woah...`);
    vanessa.talk(`Relax, it's not for you. It's for Joe, your BEST friend, remember him? Haha.`);
    mc.talk(`I do, but why are you showing this to me?`);
    vanessa.talk(`I just wanna show off my body, is that so bad?`);
    mc.talk(`Not at all.`);


    await vanessa.setQuestion(new Question({ text: `I just hope it will turn him on!`, key: `v2VanessaLastDressComment` })
        .option({ title: `Ask her to turn around`, key: `turnAround` })
        .option({ title: `Say nothing`, key: `sayNothing` }));


    if (Question.globalAnswers.v2VanessaLastDressComment === "turnAround") {

        await mc.set((properties) => {
            properties.vanessaRelationship++;
        });
        mc.talk(`You should turn around so I can make a better judgment.`);
        vanessa.talk(`There is really nothing to see in the back.`);
        ImageClass.setImage(images.v2.VanessaHomeTeaseButt);
        vanessa.talk(`You see! Absolutely nothing!`);
        mc.talk(`I can see that...`);
        vanessa.talk(`Joe really likes my ass so I like showing it to him, hehe.`);
        mc.think(`I can clearly see why he does.`);
        ImageClass.setImage(images.v2.VanessaHomeTease);
    } else {

        vanessa.talk(`Anyways, I hope he'll like it.`);
        vanessa.talk(`It's his first birthday since we started dating, and I want it to be special.`);

    }

    return jump(beachVanessaAlone6, "beachVanessaAlone6");
};

export const beachVanessaAlone6 = async (): Promise<any> => {

    vanessa.talk(`Before you leave, you need to answer the final question.`);
    await vanessa.setQuestion(new Question({ text: `Which dress did you like the most?`, key: `v2VanessaDressLikedTheMost` })
        .option({ title: `The white dress`, key: `white` })
        .option({ title: `The black dress`, key: `black` })
        .option({ title: `The red and black dress`, key: `redBlack` }));


    if (Question.globalAnswers.v2VanessaDressLikedTheMost === "black") {

        mc.talk(`The black dress.`);

    } else if (Question.globalAnswers.v2VanessaDressLikedTheMost === "white") {
        mc.talk(`The white dress.`);
    } else {
        mc.talk(`The last one.\nThe black and red dress.`);
    }

    vanessa.talk(`Noted!`);
    vanessa.talk(`That's all.\nYou see, that didn't take long at all.`);
    mc.talk(`To be honest, it really didn't.`);
    vanessa.talk(`Great! Haha.\nDo you know your way out?`);
    mc.talk(`Yeah.`);
    vanessa.talk(`Great! I'll go take a looong shower and get all the sand out, haha.`);
    mc.talk(`Cya.`);
    mc.think(`Damn. Joey has his hands full with this girl.`);


    return jump(beachVanessaAlone7, "beachVanessaAlone7");
};
export const beachVanessaAlone7 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomAlone_2, { duration: 0.6, transition: true });
    mc.think(`What the fuck was that?`);
    mc.think(`She is going out of her way to try and tease me.`);


    mc.think(`Why would she hook me up with Ann if she keeps playing me like that?`);
    mc.think(`Maybe that's how girls act when they find out the guy is almost taken.`);
    mc.think(`Or maybe that's just how she acts. I don't know her, it might be how she is.`);
    mc.think(`I wonder how Joey puts up with that.`);

    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        mc.think(`There is a way for me to learn more about her.`);
        mc.think(`I should go to the bar and snoop around to see what she was doing with the bartender.`);

    } else {

        mc.think(`I have nothing else to do for the rest of the day.`);
        mc.think(`I should give Ann a call, I haven't spoken to her since we met yesterday.`);
    }

    return jump(eveningRoutine1, "eveningRoutine1");
};

export const eveningRoutine1 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    if (!Game.seenScenarios.includes(`eveningRoutine1`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 30;
            properties.instaFollowers = 2500;
        });
    }
    await UI.add({
        key: "v2EventingRoutine",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.phone, tooltip: "Invite Ann", show: Question.globalAnswers.v1WentToTheBarWith === "ann", key: "inviteAnn" },
                { image: uiImages.barGlass, tooltip: "Go to the bar", show: Question.globalAnswers.v1WentToTheBarWith === "vanessa", key: "GoBar" }
            ]
    });
    if (UI._globalUI.v2EventingRoutine === "insta") {

        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v2EventingRoutine === "inviteAnn") {
        return jump(eveningAfterAnn, "eveningAfterAnn");

    }
    if (UI._globalUI.v2EventingRoutine === "GoBar") {
        return jump(eveningBarAlone, "eveningBarAlone");

    }
    return jump(eveningRoutine1, "eveningRoutine1");
};

export const eveningBarAlone = async (): Promise<any> => {
    ImageClass.setImage(images.v2.BarChris, { duration: 0.6, transition: true });

    // seeing bar from outside
    mc.think(`Empty again. Do they get any customers at all?`);
    mc.think(`Only Chris is there, perfect time to talk to him.`);
    ImageClass.setImage(images.v2.BarChris1);
    mc.talk(`Hey.`);
    chris.talk(`Yo. I remember you, you were here yesterday.`);
    chris.talk(`Do you want something to drink?`);
    mc.talk(`No thanks.\nI came to ask you something.`);

    chris.talk(`The place is empty, I guess I have some time.`);
    chris.talk(`How can I help you?`);

    mc.talk(`Yesterday I was here with a girl.`);
    chris.talk(`Yeah, I remember.`);
    mc.talk(`Right before I left I saw you were sitting with her.`);
    chris.talk(`True.`);
    mc.talk(`What were you doing?`);
    if (Question.globalAnswers.v1ChrisCalledVanessaGF === "sheIsNot") {
        chris.talk(`Does it really matter? It's not like she is your girlfriend or anything.`);
        mc.talk(`She is my friend's girlfriend.`);
    } else {
        chris.talk(`I must say, you have a great girlfriend.`);
        mc.talk(`She is not my girlfriend, she is my friend's girlfriend.`);
    }

    chris.talk(`Then you should tell him he has a great girlfriend, haha.`);
    mc.talk(`What is that supposed to mean?`);
    chris.talk(`Well, we chatted and she told me about her wild life and so did I.`);
    mc.talk(`That's it?`);
    chris.talk(`Not really.`);
    chris.talk(`I have a small picture that will sum it all up.\nI can just show you.`);
    await chris.setQuestion(new Question({ text: `Do you want to see it?`, key: `v2AgreeToSeeBJPic` })
        .option({ title: `Yes`, key: true })
        .option({ title: `No`, key: false }));


    if (Question.globalAnswers.v2AgreeToSeeBJPic) {
        mc.talk(`Yes, show me.`);

        ImageClass.setImage(images.v2.BarChris2);
        mc.think(`Is that what I think it is??`);

        ImageClass.setImage(images.v2.BarChris3);
        mc.think(`Holy shit, that slut! She only knew him for a couple of hours before sucking his dick...`);
        mc.think(`What am I supposed to do now? Should I tell Joey that his girlfriend is a cheating whore? Maybe I should just fuck her myself.`);
        chris.talk(`Don't look so surprised.`);

        ImageClass.setImage(images.v2.BarChris2);
        chris.talk(`I can smell girls like her from miles away.`);
        ImageClass.setImage(images.v2.BarChris1);
        mc.talk(`Listen, I've only known her for a day or two, I had no idea what she's like.`);
        chris.talk(`You want my advice?`);
        chris.talk(`Just let it go. What your friend doesn't know can't hurt him.`);
        chris.talk(`If he has even the smallest brain I bet he already knows, but doesn't give a fuck.`);
    } else {

        mc.talk(`No. I'll pass.`);
        ImageClass.setImage(images.v2.BarChris1);
        chris.talk(`Your loss.`);
        chris.talk(`I really captured her personality in that picture.\nToo bad.`);
        mc.talk(`What was that picture about anyways?`);
        chris.talk(`You had your chance to see it.`);
        mc.talk(`Fine, whatever.`);
        chris.talk(`Take my advice.`);
        chris.talk(`Keep a close eye on that chick, that's all I can give you.`);
        mc.talk(`Mmm... Not much of an help but thanks anyway, I'll tell it to my friend.`);


    }
    ImageClass.setImage(images.v2.BarChris1);
    chris.talk(`With that out of the way, are you sure I can't offer you anything to drink?`);
    mc.talk(`I'm good.`);
    chris.talk(`Ok, cya around.`);
    mc.talk(`Bye.`);
    return jump(beforeEveningRoutine, "beforeEveningRoutine");

};

export const eveningAfterAnn = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
    empty.think(`Calling Ann...`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    ann.talk(`Hey ${mc.name}! What's up?`, { method: "Over Phone" });
    mc.talk(`Hey, I'm fine.`, { method: "On Phone" });
    mc.talk(`Are you busy?`, { method: "On Phone" });
    ann.talk(`I couldn't be more free, I left the house and forgot my key.`, { method: "Over Phone" });
    ann.talk(`I'm just sitting here outside waiting for my sister to get back so I could get inside.`, { method: "Over Phone" });
    ann.talk(`She should get here any minute now.`, { method: "Over Phone" });

    mc.talk(`That's great!`, { method: "On Phone" });
    ann.talk(`Not really...`, { method: "Over Phone" });
    mc.talk(`Haha, I mean, since you don't have anything better to do you should come back to my place.`, { method: "On Phone" });
    ann.talk(`I don't know...`, { method: "Over Phone" });
    mc.talk(`Come on, it will be a great way to pass the time.`, { method: "On Phone" });
    ann.talk(`I really am bored...`, { method: "Over Phone" });
    mc.talk(`So come! I'll text you the address.`, { method: "On Phone" });
    ann.talk(`Alright, I'll be right over.`, { method: "Over Phone" });

    ImageClass.setImage(images.v1.sometimelater);

    ImageClass.setImage(images.v1.RoomAlone_2);
    empty.think(`*Door bell rings*`);

    mc.think(`That must be Ann.`);
    ImageClass.setImage(images.v2.AnaArrived);

    mc.talk(`Hey Ann!`);
    ann.talk(`Did you know we're basically neighbors?`);
    mc.talk(`Seriously?`);
    ann.talk(`Yeah, I live just down the street.\nIt took me a while to get here because I met a friend on the way.`);
    mc.talk(`It's ok. Come on in, let's go to my room.`);
    ImageClass.setImage(images.v2.AnnHome1);
    ann.talk(`Nice house, but where is everyone?`);

    if (Game.seenScenarios.includes("v1AnnBarMeeting3")) {
        mc.talk(`Don't you remember? I told you yesterday at the bar that they are always away.`);
        ann.talk(`Oh! Hehe, right.`);
        ann.talk(`What do they do?`);
        mc.talk(`Nothing really interesting, my father is a consultant for startup companies.`);
    } else {
        mc.talk(`My parents are never home.\nThey are always on business trips.`);
        ann.talk(`Oh, what do they do?`);
        mc.talk(`Business...`);
        mc.talk(`Seriously, nothing really interesting, my father is a consultant for startup companies.`);
    }

    mc.talk(`My mother usually just accompanies him.`);
    ann.talk(`That's nice.`);
    mc.talk(`Why are we standing? Let's sit.`);
    ImageClass.setImage(images.v2.AnaRoom3);
    ann.talk(`It's overwhelming being here.`);
    mc.talk(`Why?`);
    ann.talk(`Because I barely know you and here I am, at your house, sitting on your bed.`);


    mc.talk(`Have you never been at a guy's place before?`);
    ann.talk(`I have, but it's different.`);
    mc.talk(`Different how?`);

    ann.talk(`Because it's different...`);

    ann.talk(`During our date yesterday, I really felt a connection with you.`);
    ImageClass.setImage(images.v2.AnaRoom2);
    ann.talk(`Maybe it seems normal or maybe even boring for you, but I had a lot of fun.`);
    ann.talk(`It's hard for me to express emotions.`);
    ann.talk(`I'm really shy...`);
    ImageClass.setImage(images.v2.AnaRoom2);
    await ann.setQuestion(new Question({ text: `Look at me, I can't stop talking.\nI'm sorry.`, key: `v2AnnSexTalking` })
        .option({ title: `Say nothing`, key: `sayNothing` })
        .option({ title: `It's ok`, key: `itsOK` }));


    if (Question.globalAnswers.v2AnnSexTalking === "sayNothing") {
        mc.talk(`...`);
        ann.talk(`Ok...`);
        ann.talk(`So...`);
    } else {
        mc.talk(`It's ok.\nI'm listening.`);
        ImageClass.setImage(images.v2.AnaRoom3);
        ann.talk(`Oh ok great I was thinking you weren't listening to me mumbling.`);
        mc.talk(`I was, I am.`);
        ann.talk(`Great.`);
    }


    ann.talk(`As you can imagine, I never go out, much less with guys.`);
    ann.talk(`That's because I have some clue on how most of them will end up.`);
    ann.talk(`It was different with you.\nI really had a good time, especially considering it was in a place out of my comfort zone.`);
    ImageClass.setImage(images.v2.AnaRoom3);

    return jump(eveningAfterAnn2, "eveningAfterAnn2");
};

export const eveningAfterAnn2 = async (): Promise<any> => {
    ImageClass.setImage(images.v2.AnaRoom3);
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
        mc.talk(`Speaking of, what about Chris?`);
        ann.talk(`Chris?`);
        mc.talk(`The bartender.`);
        ann.talk(`What about him?`);
        mc.talk(`You said you had fun with me, but you did give him your number.`);
        ann.talk(`He called me right after I got home from the bar.`);
        mc.talk(`Not wasting his time I see.`);
        ann.talk(`Yeah... He said that his shift had ended and asked me if I wanted to come back and keep him company while he closed up.`);
        mc.talk(`And what did you say?`);
        ann.talk(`I said no, of course.`);
        ann.talk(`It was late and there's no way I'd meet up with him.`);
        ann.talk(`He's a player. That's Vanessa's type, not mine.`);
        ann.talk(`Why do you care about him anyway?`);
        mc.talk(`Just curious...`);
        ann.talk(`Oh ok.`);
    }

    ann.talk(`It's funny, I'm usually not the one who does the talking.`);
    ann.talk(`Also... I have no idea if you had fun yesterday...`);
    ann.talk(`Personally, I had a really great time and I...`);

    ImageClass.setImage(images.v2.AnaRoom3);

    await ann.setQuestion(new Question({ text: `I really like you.\nI have no idea if you feel the same.`, key: `v2LikeAnn` })
        .option({ title: `Tell her you like her`, key: true })
        .option({ title: `Tell her you don't like her`, key: false }));


    if (Question.globalAnswers.v2LikeAnn) {
        await mc.set((properties) => {
            properties.annRelationship = properties.annRelationship + 2;
            properties.annStatus = "gf";
        });
        mc.talk(`About yesterday.\nI had a really good time as well.`);
        mc.talk(`And I do like you.`);
        ann.talk(`You do? Hehe.`);
        await ann.setQuestion(new Question({ text: `It makes me so happy to hear that.`, key: `v2KissedAnn` })
            .option({ title: `Kiss her`, key: true })
            .option({ title: `Say goodbye`, key: false }));


        if (Question.globalAnswers.v2KissedAnn) {
            ImageClass.setImage(images.v2.AnaRoom7, { wait: true, duration: 1 });
            ImageClass.setImage(images.v2.AnaRoom5);
            await mc.set((properties) => {
                properties.annStatus = "gf";
                properties.annRelationship += 2;
            });
            ann.talk(`Oh... Wow.`);
            ann.talk(`I didn't expect that.`);
            ann.talk(`Not that it wasn't nice.`);
            ann.talk(`We really are moving quickly, aren't we?`);
            mc.talk(`Not at all, it was just a small kiss.`);
            ann.talk(`Yeah, you are right. Hehe.`);
            ann.talk(`Thank you for keeping me company, I had a really great time with you.`);
            ann.talk(`I need to get going now.`);

        }
        mc.talk(`It was nice seeing you again Ann...`);
        ann.talk(`Me too.`);
        ann.talk(`Bye ${mc.name}.`);

    } else {

        await mc.set((properties) => {
            properties.annStatus = "hate";
        });
        await ann.set((properties) => {
            properties.isCorrupted = true;
        });
        mc.talk(`Well...`);
        mc.talk(`About yesterday...`);

        mc.talk(`As for right now, I don't feel the way you feel about me.`);
        ImageClass.setImage(images.v2.AnaRoom2);
        ann.talk(`Oh...`);
        ann.talk(`I feel so stupid right now.`);
        ann.talk(`I am a really shy person, I usually never talk about my feelings.`);
        ann.talk(`But now I did and... I should go...`);
        ImageClass.setImage(images.v2.AnaRoom8, { duration: 1 });
        ann.talk(`Bye.`);
        ImageClass.setImage(images.v1.RoomAlone_2);
        mc.think(`She left...`);
    }
    return jump(beforeEveningRoutine, "beforeEveningRoutine");
};
export const beforeEveningRoutine = async (): Promise<any> => {

    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {
        ImageClass.setImage(images.v1.RoomAlone_2, { transition: true });
        if (mc.properties.annRelationship > 0) {
            mc.think(`That was a nice visit.`);

            // Told Ann he likes her
            if (mc.properties.annRelationship > 1) {
                mc.think(`She keeps saying she is shy, but she didn't stop me when I tried to kiss her.`);
                mc.think(`She just needs me to make the first move.`);

            } else {
                mc.think(`What a shit show...`);
                mc.think(`She took it way worse than I thought she would.`);

            }

        }
    } else {
        if (Question.globalAnswers.v2AgreeToSeeBJPic) {

            ImageClass.setImage(images.v1.RoomAlone_2, { transition: true });
            mc.think(`I already knew that Vanessa was a total slut.`);
            mc.think(`I figured she was just a tease, but seeing that picture proved me wrong.`);
            mc.think(`I really need to tell Joey.`);
            mc.think(`I don't know if it's the best idea to talk about this over the phone.`);
            mc.think(`I should keep it to myself until we meet face-to-face.`);
        } else {

            mc.think(`I wonder what was in that picture that Chris wanted to show me.`);
            mc.think(`Guess I'll never know now...`);
        }

        mc.think(`I have nothing else to do now but chill in my room...`);
    }
    return jump(beforeTruthDare, "beforeTruthDare");
};
export const beforeTruthDare = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    if (!Game.seenScenarios.includes(`beforeTruthDare`)) {
        await alex.set((properties) => {
            properties.instaProfileImage = alexProfilesPic.alexInstaPortrait2;
            properties.instaFollowing = 30;
            properties.instaFollowers = 12500;
        });
    }

    await UI.add({
        key: "v2AtRoom1",
        btns:
            [
                { image: uiImages.pc, key: "insta", tooltip: "Check Insta" },
                { image: uiImages.continue, key: "continue", tooltip: "Pass Time" }
            ]
    });
    if (UI._globalUI.v2AtRoom1 === "insta") {
        await Insta.open(getInstaData());
        if (!mc.properties.knowsAlexAndAnnFriends && getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}8`)?.mcSeen) {
            await mc.set((properties) => {
                properties.knowsAlexAndAnnFriends = true;
            });
        }
    }
    if (UI._globalUI.v2AtRoom1 === "continue") {
        return jump(truthDare1, "truthDare1");

    }
    return jump(beforeTruthDare, "beforeTruthDare");
};
export const truthDare1 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhoneReceivedCallJoey, { transition: true });
    mc.think(`Joey is calling.`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    mc.talk(`Hello?`, { method: "On Phone" });
    joe.talk(`Yo ${mc.name}. Any plans for today?`, { method: "Over Phone" });
    mc.talk(`You know me, chilling in my room.`, { method: "On Phone" });
    joe.talk(`Great! Your parents aren't coming back soon right?`, { method: "Over Phone" });
    mc.talk(`Not any time soon. Why?`, { method: "On Phone" });

    joe.talk(`I was thinking about spending the night at your place.`, { method: "Over Phone" });
    joe.talk(`I'll bring Vanessa, and you should invite Ann.`, { method: "Over Phone" });
    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {
        if (mc.properties.annRelationship === 0) {
            mc.talk(`She was here not too long ago...`, { method: "On Phone" });
            joe.talk(`Look at you!`, { method: "Over Phone" });
            mc.talk(`It didn't go the way you think it did...`, { method: "On Phone" });
            joe.talk(`Well? Come on, spill it!`, { method: "Over Phone" });
            mc.talk(`I was bored so I invited her over.`, { method: "On Phone" });
            mc.talk(`We had a small chat.`, { method: "On Phone" });
            mc.talk(`Then she kinda told me she likes me, and I said that I don't feel the same way.`, { method: "On Phone" });

            joe.talk(`Why did you say that?`, { method: "Over Phone" });
            mc.talk(`She is not really my type.`, { method: "On Phone" });
            joe.talk(`What the fuck dude, why did you invite her over just to say that?`, { method: "Over Phone" });
            mc.talk(`Sometimes I do things without reason.`, { method: "On Phone" });
            joe.talk(`Yeah no shit.`, { method: "Over Phone" });
            joe.talk(`Seriously dude, I've seen her pictures. She is really cute, you should give her a chance.`, { method: "Over Phone" });
            mc.talk(`I don't know...`, { method: "On Phone" });
            joe.talk(`You still have time to fix it!\nCall her and apologize.`, { method: "Over Phone" });
            joe.talk(`Just tell her you are sorry and that you didn't know what you were saying.`, { method: "Over Phone" });
            mc.talk(`Why do you care about her so much?`, { method: "On Phone" });
            joe.talk(`Because I planned something and her not joining us ruins it.`, { method: "Over Phone" });
            mc.talk(`Oh, I see.`, { method: "On Phone" });
            mc.talk(`I'll try to talk to her, but I can't promise anything.`, { method: "On Phone" });
        } else {

            mc.talk(`She was just here...`, { method: "On Phone" });
            joe.talk(`Look at you!`, { method: "Over Phone" });
            joe.talk(`Well? Come on, spill it!`, { method: "Over Phone" });
            mc.talk(`I was bored so I invited her over.`, { method: "On Phone" });
            mc.talk(`We had a small chat.`, { method: "On Phone" });
            if (Question.globalAnswers.v2KissedAnn) {

                mc.talk(`And then we kissed.`, { method: "On Phone" });
                joe.talk(`NICE!`, { method: "Over Phone" });
                joe.talk(`That's progress at least.`, { method: "Over Phone" });
            } else {

                mc.talk(`And then she left.`, { method: "On Phone" });
                joe.talk(`Well, at least she agreed to come to your house.`, { method: "Over Phone" });
                mc.talk(`Yeah.`, { method: "On Phone" });
            }
            mc.talk(`Anyways, I don't think she will refuse.`, { method: "On Phone" });
            mc.talk(`But don't you think I should meet with her alone?`, { method: "On Phone" });
            joe.talk(`Dude you will have plenty of time to be alone with her.\nNow is time to party!`, { method: "Over Phone" });
            mc.talk(`Fine, I'll invite her.`, { method: "On Phone" });
            joe.talk(`Great!`, { method: "Over Phone" });
        }


    } else {

        if (mc.properties.metAnn) {

            mc.talk(`I'll give it a shot, but I can't promise anything.`, { method: "On Phone" });
            joe.talk(`Why? Didn't you have fun at the bar?`, { method: "Over Phone" });
            mc.think(`He doesn't even know I was there with his girlfriend...`);
            mc.talk(`Yeah, we did.`, { method: "On Phone" });
            joe.talk(`So what's the problem?`, { method: "Over Phone" });
            mc.talk(`No problem... I'll call her.`, { method: "On Phone" });
            joe.talk(`Great!`, { method: "Over Phone" });
        } else {
            mc.think(`How am I supposed to invite a girl I haven't even meet?`);
            mc.talk(`I dunno about that...`, { method: "On Phone" });
            joe.talk(`I won't take no for an answer.`, { method: "Over Phone" });
            mc.think(`I need a good excuse.`);
            mc.talk(`She just met me, why would she agreed to come over to my house?`, { method: "On Phone" });
            joe.talk(`Damn, you're right...`, { method: "Over Phone" });
            joe.talk(`I'll ask Vanessa to give her a call.`, { method: "Over Phone" });
            mc.think(`That was easy.`);
        }

    }


    joe.talk(`Anyways, I'm waiting for Vanessa, and then we'll come over to your place.`, { method: "Over Phone" });
    mc.talk(`Do I need to set anything up?`, { method: "On Phone" });
    joe.talk(`No.`, { method: "Over Phone" });
    joe.talk(`Cya dude.`, { method: "Over Phone" });

    return jump(beforeTruthDare1v1, "beforeTruthDare1v1");
};
export const beforeTruthDare1v1 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {
        mc.think(`I wonder why he insisted Ann had to be there.`);
        mc.think(`I have no idea what's going on inside his head anymore.`);

        if (mc.properties.annRelationship === 0) {
            ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
            mc.think(`I am really skeptical she would want to come.`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);

            ann.talk(`Hey ${mc.name}...`, { method: "Over Phone" });
            mc.talk(`Hey Ann, how are you?`, { method: "On Phone" });
            ann.talk(`I am really busy right now, is it important?`, { method: "Over Phone" });
            mc.talk(`Joe and Vanessa are coming over tonight, you should join us as well it would be fun.`, { method: "On Phone" });
            ann.talk(`I have plans.`, { method: "Over Phone" });
            mc.talk(`Hey Ann, I'm sorry about earlier.\nI didn't mean it.`, { method: "On Phone" });
            ann.talk(`There is nothing to be sorry for, you were just being honest.`, { method: "Over Phone" });
            mc.talk(`I don't know why I said that.`, { method: "On Phone" });
            ann.talk(`Alright...`, { method: "Over Phone" });
            mc.talk(`Will you come tonight?`, { method: "On Phone" });
            ann.talk(`I'll think about it.`, { method: "Over Phone" });
            mc.talk(`Ok. Bye Ann.`, { method: "On Phone" });
            ann.talk(`Bye.`, { method: "Over Phone" });
            mc.think(`That was awkward...`);
            mc.think(`The things I do for Joey...`);
        } else {
            ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
            empty.think(`Calling Ann...`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            ann.talk(`Hey ${mc.name}!`, { method: "Over Phone" });
            mc.talk(`Hey Ann, how are you?`, { method: "On Phone" })
                ;
            ann.talk(`I am great what's up?`, { method: "Over Phone" });
            mc.talk(`Joey and Vanessa are coming over tonight.\nWould you like to come?`, { method: "On Phone" });
            ann.talk(`Sure! What are we going to do?`, { method: "Over Phone" });

            mc.talk(`I have no idea yet, it was Joey's idea, they are planning to sleep over.`, { method: "On Phone" });
            ann.talk(`I don't know about sleeping over... But I'll come.`, { method: "Over Phone" });
            mc.talk(`Great... So see you tonight.`, { method: "On Phone" });
        }


    } else {
        if (mc.properties.metAnn) {

            mc.think(`I am not ready to talk to her after I cancelled our date.`);
            mc.think(`Besides, Vanessa owes me a favor for not telling Joey a thing.`);

            mc.think(`So fuck calling Ann, I'll ask Vanessa to do that.`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            empty.think(`Phone is dialing...`);
            vanessa.talk(`Hey ${mc.name}! Missed me already?`, { method: "Over Phone" });
            mc.talk(`Hey Vanessa, I need your help.`, { method: "On Phone" });
            vanessa.talk(`Sure, what do you need me to do?`, { method: "Over Phone" });
            mc.talk(`Has Joey told you about you guys coming to my place later?`, { method: "On Phone" });
            vanessa.talk(`He did.`, { method: "Over Phone" });
            mc.talk(`So, he asked me to invite Ann. He wants her to be there for some reason.`, { method: "On Phone" });
            mc.talk(`Since I ditched her the other day to go with you, I need you to invite her.`, { method: "On Phone" });
            vanessa.talk(`That's it?`, { method: "Over Phone" });
            mc.talk(`Yup, that's all.`, { method: "On Phone" });
            vanessa.talk(`Easy peasy.`, { method: "Over Phone" });
            mc.talk(`Thanks!`, { method: "On Phone" });
            vanessa.talk(`Cya later!`, { method: "Over Phone" });

            mc.think(`That was easy.`);
        } else {

            mc.talk(`Vanessa is going to invite her so I don't have anything else to do but to wait for them.`);
        }

    }
    ImageClass.setImage(images.v1.sometimelater);
    ImageClass.setImage(images.v2.TOD1, { transition: true });
    doDoorRing();
    mc.think(`That must be them.`);

    ImageClass.setImage(images.v2.TOD2);
    joe.talk(`My man!`);
    mc.talk(`Hey Joey!`);
    joe.talk(`I give up trying to get you to call me Joe.`);
    mc.talk(`Yeah... You will always be Joey to me.`);
    vanessa.talk(`Joey is kinda cute. I can work with Joey.`);
    joe.talk(`Nah, I prefer Joe.`);
    mc.talk(`Don't just stand there, come in!`);

    ImageClass.setImage(images.v2.TOD6, { transition: true });

    mc.talk(`Do you want anything to drink?`);
    joe.talk(`No, but we need to do something with this table.`);
    mc.talk(`What's wrong with it?`);
    joe.talk(`We need to move it.`);
    mc.talk(`Move it?`);
    joe.talk(`Yes, help me.`);
    ImageClass.setImage(images.v2.TOD4);
    mc.talk(`What do you want to do with it?`);
    joe.talk(`Just put it in the corner there.`);
    ImageClass.setImage(images.v2.TOD5);
    joe.talk(`Great!`);
    mc.talk(`Why did we do that?`);
    joe.talk(`To clear some room.`);
    joe.talk(`By the way, where's Ann?`);
    mc.talk(`She's not here yet.`);
    joe.talk(`Oh, she wants to make an entrance huh!`);
    vanessa.talk(`No way, she must be busy reading a book or something.`);
    mc.talk(`Right, so, what's the plans for tonight?`);
    joe.talk(`I have some things in mind.`);
    mc.talk(`Like what?`);
    joe.talk(`You will see.`);
    vanessa.talk(`Joe has the best ideas!`);
    doDoorRing();
    mc.talk(`That must be Ann.`);
    mc.talk(`I'll go get the door.`);
    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {
        if (mc.properties.annRelationship === 0) {
            ImageClass.setImage(images.v2.TOD3_1);
            mc.talk(`Hey Ann.`);
            ann.talk(`Hey...`);
            mc.talk(`I want to apologize again for earlier.`);
            ann.talk(`It kinda bummed me out, but I'm fine now.`);
            ann.talk(`Did Vanessa get here already?`);
            mc.talk(`Yeah, she is in the living room with Joe.`);
        } else {
            ImageClass.setImage(images.v2.TOD3);
            mc.talk(`Hey Ann!`);
            ann.talk(`Hey!`);
            mc.talk(`I am glad you came.`);
            ann.talk(`Me too hehe.`);
            mc.talk(`Come on in, Joe and Vanessa are in the living room.`);
        }


    } else {
        ImageClass.setImage(images.v2.TOD3);
        if (mc.properties.metAnn) {
            mc.talk(`Hey Ann.`);
            ann.talk(`Hey! ${mc.name}!`);
            mc.think(`How come she isn't angry after I canceled our date?`);

            ann.talk(`Before I go inside, I just want to say that I know about Vanessa's plan to surprise Joe. She told me.`);
            ann.talk(`So, I am not angry at you for going to the bar with her.\nIt was for a good cause.`);
            ann.talk(`And of course I'm not going to say a thing to Joe, your secret is safe with me!`);
            mc.talk(`Great, thanks!\nCome in, they are in the living room.`);
            mc.think(`Vanessa did fix everything.`);
        } else {
            mc.talk(`Hey. Ann?`);
            ann.talk(`Hey! Yes, you must be ${mc.name}.`);
            mc.talk(`That's correct.`);
            ann.talk(`I hope it's not weird that I came here without even knowing you.`);
            mc.talk(`Not at all.`);
            ann.talk(`Great! I hope I didn't get here first.`);
            mc.talk(`You didn't, Vanessa and Joe are in the living room.`);
            ann.talk(`Great!`);
            ann.talk(`By the way.\nI know about Vanessa's plan to surprise Joe. She updated me.`);
            ann.talk(`I know that Joe's thinks that I went out with you the other day, I'm going to play along.`);
            mc.talk(`Oh great!`);
            ann.talk(`Of course, it's for a good cause.`);
        }

    }

    ann.talk(`I hope you don't mind that I brought a book.`);
    mc.talk(`Not at all. you can put it in my room.`);
    ann.talk(`Thanks.`);
    ImageClass.setImage(images.v2.TOD7, { transition: true });
    vanessa.talk(`Hey girlfriend!`);
    ann.talk(`Hey Vanessa.`);
    mc.talk(`I believe you haven't had the chance to meet Joe, right?`);
    ann.talk(`No... not in person I only heard stories about him.`);
    joe.talk(`Stories? Like what? Please share.`);
    ann.talk(`Nothing special really. Just how you guys met and the fact that you like working out and have a great sense of humor.`);
    mc.talk(`That's me.`);


    joe.talk(`Ok, so everything is ready, let's start.`);
    mc.talk(`Start what?`);
    joe.talk(`We are going to play a game...`);
    joe.talk(`${mc.name}, can you get us an empty bottle?`);
    mc.talk(`Sure.`);


    ImageClass.setImage(images.v2_5.TOD8, { duration: 0.6, transition: true });
    // <action type="css" text-color="#FFDC70"/>
    joe.talk(`Ok so now we are all set!`);
    ann.talk(`Mhmm... Sitting in circle, on the floor with a bottle. Are we going to play truth or dare?`);
    joe.talk(`That's right!`);
    vanessa.talk(`I told you she is smart! Haha.`);
    ann.talk(`I don't know about this guys... I thought we were just gonna sit and watch some movies... Maybe talk for a bit.`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);
    vanessa.talk(`Come on Ann. Don't be a party popper. What's the worst that could happen?`);
    ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
    ann.talk(`I don't know, I've heard stories...`);
    ann.talk(`If I'm going to play this, then we need to set some ground rules.`);
    vanessa.talk(`Geez. Fine. What kind of rules did you have in mind?`);
    ann.talk(`First, I am not going to get naked here.`);
    ann.talk(`Second, I am not going to have sex here of course.`);
    vanessa.talk(`Everyone, let's wrap it up. We can go home, there is nothing more to see here.`);
    ann.talk(`...`);
    vanessa.talk(`I AM JOKING!`);

    if (mc.properties.annRelationship > 0) {

        ann.talk(`I already know ${mc.name} a bit and I know he won't do anything like that. Vanessa is the one I'm scared of.`);
    } else {

        ImageClass.setImage(images.v2_5.TOD8.partials.TODAnnLookingAtVanessa);
        ann.talk(`I'm scared of Vanessa. I know what she is capable of.`);
    }


    ImageClass.setImage(images.v2_5.TOD8.partials.TODVanessaLookingAtAnn);

    vanessa.talk(`Relax! It's going to be fun.`);
    ann.talk(`Ok, I'm in.`);
    ImageClass.setImage(images.v2.TOD8_2);
    joe.talk(`Ok before we start, ${mc.name} do you have a charger for Android? I forgot to charge my phone.`);
    mc.talk(`Yes, you can go to my room, I think I have one there.`);
    joe.talk(`You know I never find anything by myself.`);
    mc.talk(`Alright, I'll help you look.`);
    ImageClass.setImage(images.v1.ThinJoey3);
    mc.talk(`The charger should be near the TV...`);
    ImageClass.setImage(images.v1.ThinJoey4);
    joe.talk(`Listen I don't care about that, I just wanted to have a word with you in private.`);
    mc.talk(`Sure, what's it about?`);
    joe.talk(`Ann is really cute!\nEven better in person.`);
    joe.talk(`I had only seen her in photos.`);
    if (mc.properties.annRelationship > 0) {
        mc.talk(`Yes she is.`);
    }

    joe.talk(`I was thinking we could spice things up.\nWould you be jealous if we mixed things up a bit?`);
    mc.talk(`What do you mean?`);
    joe.talk(`I was thinking, it would be more interesting if I could dare Ann to do some stuff with me.`);

    mc.talk(`Are you serious? What about Vanessa?`);
    joe.talk(`Yeah, about that, you can dare her to do whatever as well.`);
    mc.talk(`That's fucked up.`);
    joe.talk(`It's just harmless fun, no one will get hurt.`);
    if (mc.properties.annRelationship === 0) {
        mc.talk(`Why do you need my approval anyway? It's not like she's my girlfriend or anything.`);
        if (mc.properties.annStatus === "natural") {

            mc.think(`I can't tell him I didn't go out with her to the bar. It would ruin everything.`);
        }
        joe.talk(`Since Vanessa and I are a couple, and both you and Ann are single, I thought it would look like I'm trying to steal Ann as well.`);
    }
    if (Question.globalAnswers.v1EnableNTR || mc.properties.annStatus === "hate") {
        ImageClass.setImage(images.v1.ThinJoey3);
        await joe.setQuestion(new Question({ text: `So, what do you say?\nCan I fool around with Ann?`, key: `v25JoeTODAgree` })
            .option({ title: `Agree`, key: true })
            .option({ title: `Disagree`, key: false }));


        if (Question.globalAnswers.v25JoeTODAgree) {
            ImageClass.setImage(images.v1.ThinJoey3);

            mc.talk(`I'm ok with that, you can dare Ann to do whatever and I'll do the same with Vanessa.`);
            joe.talk(`Great!`);
        } else {
            joeTODRefuse();
        }

    } else {

        joeTODRefuse();

    }

    return jump(truthDare2_2, "truthDare2_2");
};

export const joeTODRefuse = async (): Promise<any> => {
    if (mc.properties.annRelationship > 0) {
        mc.talk(`To tell you the truth, things are just starting to go in the right direction between Ann and me.`);
        joe.talk(`Right, I understand.`);

    }
    mc.talk(`I think you should stick to Vanessa and I'll stick to Ann.`);
    mc.talk(`I hope I didn't ruin your plans.`);
    ImageClass.setImage(images.v1.ThinJoey4);
    joe.talk(`You didn't, it was just a spontaneous idea.`);
};


export const truthDare2_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.ThinJoey4);
    joe.talk(`One last thing.`);
    joe.talk(`I've spent a lot of time practicing spinning the bottle. I can almost control on whom it lands.`);
    joe.talk(`But it's not perfect so if it lands on you just go with the flow.`);
    mc.talk(`That's sneaky.`);
    joe.talk(`You bet! Haha.`);


    mc.talk(`You really know how to get the most out of your free time.`);
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {
        mc.think(`Now's the perfect opportunity to tell Joey about Vanessa and Chris.`);
        mc.talk(`Joey, before we get back, there is something I need to tell you.`);
        joe.talk(`It can wait, the girls will get suspicious if we're gone too long.`);
        mc.talk(`Are you sure? It's really important.`);
        joe.talk(`I'm sure, let's go.`);
    }
    ImageClass.setImage(images.v2.TOD8_3);
    // <action type="css" text-color="#FFDC70"/>
    vanessa.talk(`Took you long enough! Were you guys waiting for the phone to be fully charged?`);
    joe.talk(`No, I told you, he keeps losing the charger so we had to look for it.`);
    vanessa.talk(`Right.`);
    mc.talk(`Ok. Are you guys ready?`);
    vanessa.talk(`Ready!`);
    ann.talk(`Ready.`);
    mc.think(`Time to see what Joey has in mind.`);
    return jump(TODManager, "TODManager");
};